import {Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output} from "@angular/core";

@Directive({
    selector: '[clickOutside]'
})
export class ClickOutsideDirective implements OnInit, OnDestroy {
    constructor(private _elementRef: ElementRef) {
    }

    @Output()
    public clickOutside = new EventEmitter<MouseEvent>();

    ngOnInit() {
        setTimeout(() => {
            document.addEventListener('click', this.onClick.bind(this))
        }, 300)
    }

    ngOnDestroy() {
        document.removeEventListener('click', this.onClick);
    }

    public onClick(event: MouseEvent): void {
        const targetElement = event.target;
        if (!targetElement) {
            return;
        }

        const clickedInside = this._elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.clickOutside.emit(event);
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/directives/click-outside.directive.ts